import React, { useCallback } from "react";
import useHotkey from "hooks/useHotkey";
import HotkeyModal from "components/hotkeys/HotkeysModal";
import useHotkeysContext from "hooks/useHotkeysContext";
const HotkeysModalContainer = () => {
  const { showHotkeysModal, setShowHotkeysModal } = useHotkeysContext();
  const toggleModal = useCallback(() => setShowHotkeysModal((cur) => !cur), [setShowHotkeysModal]);
  useHotkey({
    actionKey: "show-hotkeys-modal",
    callback: () => setShowHotkeysModal(true),
    scope: "general"
  });
  if (!showHotkeysModal) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(HotkeyModal, { onToggle: () => toggleModal() });
};
export default HotkeysModalContainer;
